import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Layout, message, Select } from 'antd';
import isEmpty from 'lodash/isEmpty';
import SummaryTable from './SummaryTable';
import { DEFAULT_PAGINATION_PROPS } from './constants';
import { PageContent, PageSpace, SummaryHeader } from '../styled';
import { DeployButton, DeploySummaryButton } from './styled';
import {
  TM_FRAUD_SOURCE_IDS,
  ITEM_OPERATIONS
} from '../../../../util/GlobalConstant';
import { isResourceAvailable } from '../../../../util/index';
import style from './index.scss';
import { returnFraudUserAccessByResource } from '../../../../util/TmFraudModuleFilter';
import { getSelectedResources } from '../../../../util/resourceManager';
const { Content } = Layout;

const { trmResources } = getSelectedResources();

const Summary = ({
  scenarios,
  isLoading,
  error,
  summaryAPIActions,
  triggeredScenarioStatus,
  authentication,
  from,
  trmActions,
  alertLevels
}) => {
  const {
    fetchAllScenarios,
    cloneScenario,
    fetchTypologiesActions,
    fetchAMLSAlertLevel
  } = summaryAPIActions;
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION_PROPS);
  const [selectedScenario, setSelectedScenario] = useState(null);
  const [isFraud, setIsFraud] = useState(false);
  const [isTMuser, setIsTMuser] = useState(false);
  const [currentSelectedFilter, setCurrentSelectedFilter] = useState('');
  const [typlogyActions, setTypologyActions] = useState();

  useEffect(() => {
    const { current, pageSize } = pagination;
    fetchAllScenarios({
      page: current,
      pageSize
    });
    const userAccess = returnFraudUserAccessByResource(
      authentication,
      trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE,
      ITEM_OPERATIONS.READ
    );
    setIsFraud(userAccess.isFraud);
    setIsTMuser(userAccess.isTMuser);

    // Fetch alert level config to display alert level and color from the config
    if (!alertLevels?.length) {
      fetchAMLSAlertLevel();
    }
  }, []);

  useEffect(() => {
    const userAccess = returnFraudUserAccessByResource(
      authentication,
      trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE,
      ITEM_OPERATIONS.READ
    );
    if (userAccess.isRTUser) {
      fetchTypologiesActions();
    }
  }, []);

  useEffect(() => {
    setTypologyActions(trmActions?.data);
  }, [trmActions]);

  useEffect(() => {
    if (!isEmpty(error) && !isLoading) {
      console.log('error', error);
      message.error(error.message, 3);
    }
  }, [error]);

  useEffect(() => {
    if (triggeredScenarioStatus?.data?.message) {
      message.error(triggeredScenarioStatus?.data?.message);
    }
  }, [triggeredScenarioStatus]);

  const onPaginationChange = useCallback((page, pageSize) => {
    setPagination({
      current: page,
      pageSize
    });
    if (currentSelectedFilter === 'TM') {
      fetchAllScenarios({
        page,
        pageSize,
        sourceId: TM_FRAUD_SOURCE_IDS.TM
      });
    } else if (currentSelectedFilter === 'Fraud') {
      fetchAllScenarios({
        page,
        pageSize,
        sourceId: TM_FRAUD_SOURCE_IDS.FRAUD
      });
    } else {
      fetchAllScenarios({
        page,
        pageSize
      });
    }
  });

  const onDropDownFilterChange = (selectedValue) => {
    const { pageSize } = pagination;
    if (selectedValue === 'TM') {
      setCurrentSelectedFilter('TM');
      fetchAllScenarios({
        page: 1,
        pageSize,
        sourceId: TM_FRAUD_SOURCE_IDS.TM
      });
    } else if (selectedValue === 'Fraud') {
      setCurrentSelectedFilter('Fraud');
      fetchAllScenarios({
        page: 1,
        pageSize,
        sourceId: TM_FRAUD_SOURCE_IDS.FRAUD
      });
    } else if (selectedValue === 'All') {
      setCurrentSelectedFilter('All');
      fetchAllScenarios({
        page: 1,
        pageSize
      });
    }
  };

  return (
    <Content>
      <PageSpace size={5} direction="vertical">
        <PageContent>
          <SummaryHeader>
            {isFraud && isTMuser ? (
              <Select
                className={style.selectFilter}
                options={[
                  { value: 'All', label: 'All' },
                  { value: 'TM', label: 'TM' },
                  { value: 'Fraud', label: 'Fraud' }
                ]}
                style={{ width: '150px', marginRight: '15px' }}
                defaultValue="All"
                onChange={(e) => onDropDownFilterChange(e)}
              />
            ) : (
              ''
            )}
            {isResourceAvailable(
              { data: authentication },
              trmResources.APP_3_RESOURCE_UI_AMLS_CHAMPION
            ) && (
              <DeploySummaryButton
                btnType="secondary"
                btnText="Deploy in Production Summary"
                routeToGo={'/app/trm/deployInProduction'}
              />
            )}

            {isResourceAvailable(
              { data: authentication },
              trmResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET_WRITE
            ) && (
              <DeployButton
                btnType="primary"
                btnText="Deploy in Production"
                disabled={!selectedScenario}
                routeToGo={`/app/trm/deployInProduction/${selectedScenario}`}
              />
            )}
          </SummaryHeader>
          <SummaryTable
            isLoading={isLoading}
            cloneScenario={cloneScenario}
            scenarios={scenarios?.scenarios || []}
            paginationProps={pagination}
            from={from}
            onPaginationChange={onPaginationChange}
            totalScenarios={scenarios?.metadata?.total}
            onScenarioSelect={(value) => setSelectedScenario(value)}
            authentication={authentication}
            hasAccessToDeployToProduction={isResourceAvailable(
              { data: authentication },
              trmResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET_WRITE
            )}
            typlogyActions={typlogyActions}
          />
        </PageContent>
      </PageSpace>
    </Content>
  );
};

Summary.propTypes = {
  scenarios: PropTypes.object,
  summaryAPIActions: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.object,
  alertLevels: PropTypes.array
};

export default Summary;
